import React from 'react'
import { Link} from 'gatsby'
import { DateDisplay } from '@utils/DateDisplay'


const ItemsList = ({items}) => {

    if(!items) return null;
    return (
        <>
        {items.map(item => (
            <>
                <div className="py-4" key={item.id}>
                    <h2 className="h3">
                        <Link className="animated" to={ item.url}>{item.data.title}</Link>
                    </h2>
                    <div className="d-md-flex justify-content-md-start">
                        <span className="font-italic mr-4">{DateDisplay(item.data.date_published)}</span>    
                    </div> 
                </div>  
                
            </> 
            ))
        } 
        </>
    )
}

export default ItemsList;
